export default __webpack_public_path__ + "static/media/goffMideon.4d3faba1.png";